import "./footer.css";
import '../fonts.css';

function Footer () {
    return (
        <div className="footercontainer">
            <div className="linkrow">
                <p>Omassa Kuplassa</p>
                <p>Lopputyö</p>
                <p>Viestintä ja digitaalinen media</p>
                <p>Ryhmä 5</p>
                <p>Peppi Palokangas</p>
                <p>Konsta Raitanen</p>
                <p>Mario Sok</p>
                <p>Ohto Sysilä</p>
            </div>
            <div><img src="https://yle.fi/uutiset/assets/img/vastuullista-journalismia.svg" alt="Vastuullista journalismia" height="50px" /></div>
            <div><img src="/resources/images/yle-logo-musta-crop.png" alt="Yle" height="50px" />  </div>
                 
                
        </div>
    )
}

export default Footer